import { Badge } from "@qn/ui";
import { AlertTriangle, Check } from "lucide-react";
import { useT } from "../lib/i18n";

export type Cost = "free" | "quota" | "paid" | undefined;

/** Anything that can cost money is flagged in red; unknown cost counts as paid. */
export function CostBadge({ cost, compact }: { cost: Cost; compact?: boolean }) {
  const t = useT();
  if (cost === "free")
    return (
      <Badge tone="success" title={t("cost.freeHint")}>
        <Check className="size-3" /> {t("cost.free")}
      </Badge>
    );
  const label = cost === "quota" ? t("cost.quota") : t("cost.paid");
  return (
    <Badge tone="danger" title={cost === "quota" ? t("cost.quotaHint") : t("cost.paidHint")}>
      <AlertTriangle className="size-3" /> {compact ? (cost === "quota" ? "$?" : "$") : label}
    </Badge>
  );
}
